import { render } from "./BannerView.vue?vue&type=template&id=4c062270"
import script from "./BannerView.vue?vue&type=script&lang=js"
export * from "./BannerView.vue?vue&type=script&lang=js"

import "./BannerView.vue?vue&type=style&index=0&id=4c062270&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vue-noelo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__